import { isSupportRequestEnabled } from '../constants/support-feature.constant.js'

const routes = [
  {
    name: 'my-support-requests',
    path: '/support-requests',
    meta: {
      requiresAuth: true,
      layout: 'home',
      breadcrumb: {
        label: 'support.panel.breadcrumb',
        route: 'my-support-requests',
      },
    },
    beforeEnter: (to, from, next) => {
      next(isSupportRequestEnabled() ? undefined : { path: '/' })
    },
    component: () =>
      import('@/modules/support/containers/my-support-requests.container.vue'),
  },
]

export default routes
